import { Navigate, Outlet, useLocation, matchPath } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import PageSkeleton from '../components/ui/PageSkeleton';
import { getAuthenticatedHomeRoute, isTenantSubdomain } from '../utils/domain';
import { useEffect } from 'react';
import http from '../services/http';

const guestOnlyRoutes = [
    '/',
    '/login',
    '/ssologin',
    '/forgot-password',
    '/forgot-password-login',
    '/forgot-password-email',
    '/reset-password/:token',
];

function isGuestOnlyPath(pathname: string) {
    return guestOnlyRoutes.some((pattern) => matchPath({ path: pattern, end: true }, pathname));
}

export default function GuestRoute() {
    const initialized = useAuthStore((state) => state.initialized);
    const user = useAuthStore((state) => state.user);
    const clearUser = useAuthStore((state) => state.clearUser);
    const location = useLocation();
    const authenticatedHomeRoute = getAuthenticatedHomeRoute();
    //AUTO CLEAN TOKEN ON GUEST ROUTES
    useEffect(() => {
        if (isGuestOnlyPath(location.pathname)) {
            //Only clear for landlord (token-based)
            if (!isTenantSubdomain()) {
                localStorage.removeItem('token');
                delete http.defaults.headers.common['Authorization'];
            }

            //Always clear Zustand user
            clearUser();
        }
    }, [location.pathname, clearUser]);

    if (!initialized) {
        return <PageSkeleton />;
    }

    //If already logged in AND trying to access login page manually
    if (user && isGuestOnlyPath(location.pathname)) {
        return <Navigate to={authenticatedHomeRoute} replace />;
    }

    return <Outlet />;
}
